// features/cashierAssistance/cashierThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const fetchCashierTicketsThunk = createAsyncThunk(
  'cashierTickets/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      // Backend paginates (limit/offset, default 20, max 100). Request a
      // full page and unwrap so the slice keeps receiving a plain array.
      const { data } = await axiosInstance.get('/api/cashier-assistance/tickets/',
        { params: { limit: 100, ...params } });
      return Array.isArray(data) ? data : (data.results ?? []);
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to load tickets' });
    }
  }
);

export const updateCashierTicketThunk = createAsyncThunk(
  'cashierTickets/update',
  async ({ ticketId, updates }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.patch(
        `/api/cashier-assistance/tickets/${ticketId}/`, updates
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Failed to update ticket' });
    }
  }
);